import { z } from 'zod';

/** Chaves estáveis que os consumidores traduzem em `errors:validation.*`. */
export const VALIDATION_ERROR_KEYS = [
  'required', 'invalidType', 'tooSmall', 'tooBig', 'email', 'url', 'uuid', 'regex', 'custom',
  'invalidDate', 'ageRestriction', 'passwordMismatch',
] as const;

export type ValidationErrorKey = (typeof VALIDATION_ERROR_KEYS)[number];

export type ValidationIssueDescriptor = {
  key: ValidationErrorKey;
  values?: Record<string, number>;
};

function isValidationErrorKey(value: unknown): value is ValidationErrorKey {
  return typeof value === 'string' && (VALIDATION_ERROR_KEYS as readonly string[]).includes(value);
}

/** Converte somente os erros conhecidos do Zod em uma chave estável, sem depender de i18n. */
export function getValidationIssueDescriptor(issue: z.ZodIssueOptionalMessage): ValidationIssueDescriptor | null {
  switch (issue.code) {
    case z.ZodIssueCode.invalid_type:
      return { key: issue.received === z.ZodParsedType.undefined || issue.received === z.ZodParsedType.null ? 'required' : 'invalidType' };
    case z.ZodIssueCode.too_small:
      return { key: 'tooSmall', values: { min: Number(issue.minimum) } };
    case z.ZodIssueCode.too_big:
      return { key: 'tooBig', values: { max: Number(issue.maximum) } };
    case z.ZodIssueCode.invalid_string:
      if (issue.validation === 'email') return { key: 'email' };
      if (issue.validation === 'url') return { key: 'url' };
      if (issue.validation === 'uuid') return { key: 'uuid' };
      if (issue.validation === 'regex') return { key: 'regex' };
      return { key: 'invalidType' };
    case z.ZodIssueCode.custom:
      return isValidationErrorKey(issue.params?.errorKey) ? { key: issue.params.errorKey } : { key: 'custom' };
    default:
      return null;
  }
}
